
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"400","height":"129.62","viewBox":"0 0 105.833 34.295"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticStyle:{"line-height":"1.25","-inkscape-font-specification":"'Arial, Normal'"},attrs:{"aria-label":"UNO!","font-size":"44.777","font-family":"Arial","letter-spacing":"0","word-spacing":"0","fill":"#fefefe","stroke":"#000","stroke-width":"1.128"}},[_c('path',{attrs:{"d":"M21.531 1.133h4.242V19.65q0 4.832-1.093 7.674-1.093 2.843-3.958 4.635-2.842 1.771-7.477 1.771-4.504 0-7.368-1.552-2.864-1.552-4.089-4.482Q.564 24.745.564 19.65V1.133h4.242v18.496q0 4.176.765 6.166.787 1.968 2.667 3.039 1.902 1.071 4.635 1.071 4.68 0 6.669-2.12 1.99-2.121 1.99-8.156zM32.791 33.185V1.133h4.351l16.835 25.165V1.133h4.067v32.052h-4.351L36.858 7.998v25.187zM63.881 17.574q0-7.98 4.286-12.484Q72.452.564 79.23.564q4.438 0 8.002 2.12 3.563 2.122 5.422 5.926 1.88 3.782 1.88 8.592 0 4.876-1.968 8.724-1.967 3.848-5.575 5.838-3.607 1.967-7.783 1.967-4.526 0-8.09-2.186t-5.4-5.969q-1.837-3.782-1.837-8.002zm4.373.066q0 5.794 3.105 9.139 3.126 3.323 7.827 3.323 4.788 0 7.87-3.367 3.105-3.367 3.105-9.554 0-3.914-1.333-6.822-1.312-2.93-3.87-4.526-2.536-1.618-5.707-1.618-4.503 0-7.761 3.105-3.236 3.083-3.236 10.32zM101.596 25.226l-1.202-16.988V1.133h4.875v7.105l-1.137 16.988zm-1.027 7.959v-4.482h4.525v4.482z"}})])])
          )
        }
      }
    